var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.drawer,attrs:{"onchange":_vm.tamano}},[_c('barraSuperior'),_vm._v(" "),_c('navegacionLateral'),_vm._v(" "),_c(_vm.currentTabComponent(),{tag:"component"}),_vm._v(" "),_c('footerPanel')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-257514b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panel.vue
// module id = null
// module chunks = 